
export default function FeaturedCaseStudiesSection() {
  const caseStudies = [
    {
      title: "National Retail Chain",
      image: "https://readdy.ai/api/search-image?query=Modern%20retail%20store%20interior%20with%20professional%20staff%20training%2C%20customer%20service%20excellence%2C%20retail%20operations%2C%20shopping%20mall%20environment%2C%20professional%20retail%20workers%20in%20uniform%2C%20clean%20organized%20store%20layout&width=600&height=400&seq=retail-case&orientation=landscape",
      challenge: "High staff turnover (45% annually) and inconsistent customer service standards across 150+ stores nationwide.",
      solution: "Implemented comprehensive Retail Operations Excellence programme with standardized training modules, mentorship systems, and performance tracking.",
      results: [
        "Reduced staff turnover by 32%",
        "Improved customer satisfaction scores by 28%",
        "Increased sales per employee by 18%",
        "Achieved 95% training completion rate"
      ],
      testimonial: "The transformation in our workforce has been remarkable. Our employees are more confident, our customers are happier, and our bottom line reflects the positive changes.",
      author: "Regional Training Manager",
      sector: "Retail"
    },
    {
      title: "Fast-Food Franchise",
      image: "https://readdy.ai/api/search-image?query=Fast%20food%20restaurant%20kitchen%20with%20professional%20staff%20working%20efficiently%2C%20food%20service%20training%2C%20restaurant%20operations%2C%20clean%20commercial%20kitchen%20environment%2C%20team%20collaboration%20in%20food%20preparation&width=600&height=400&seq=fastfood-case&orientation=landscape",
      challenge: "Inconsistent food quality and service speed across 85 franchise locations, leading to customer complaints and brand reputation issues.",
      solution: "Deployed Leadership & Management Development programme combined with operational excellence training for franchise owners and managers.",
      results: [
        "Improved service speed by 25%",
        "Reduced customer complaints by 40%",
        "Increased franchise profitability by 22%",
        "Enhanced food safety compliance to 98%"
      ],
      testimonial: "Sylman Academy didn't just train our people - they transformed our entire operational culture. The results speak for themselves.",
      author: "Franchise Operations Director",
      sector: "Food Service"
    },
    {
      title: "Agricultural Co-operative",
      image: "https://readdy.ai/api/search-image?query=Agricultural%20cooperative%20facility%20with%20farmers%20and%20workers%20learning%20modern%20farming%20techniques%2C%20agricultural%20training%20center%2C%20rural%20development%2C%20sustainable%20farming%20practices%2C%20professional%20agricultural%20education&width=600&height=400&seq=agriculture-case&orientation=landscape",
      challenge: "Limited business skills among 200+ smallholder farmers, resulting in poor market access and low profitability.",
      solution: "Delivered New Venture Creation & Entrepreneurship programme tailored for agricultural sector, including market linkage support.",
      results: [
        "Increased average farm income by 35%",
        "Established 12 new agribusiness ventures",
        "Improved market access for 180 farmers",
        "Created 45 new employment opportunities"
      ],
      testimonial: "This programme opened our eyes to possibilities we never knew existed. Our farmers are now entrepreneurs, not just producers.",
      author: "Co-operative Development Manager",
      sector: "Agriculture"
    }
  ];

  return (
    <section className="section-wrap bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Featured Case Studies
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover how our training solutions have delivered measurable results for businesses across different industries.
          </p>
        </div>

        <div className="space-y-16">
          {caseStudies.map((study, index) => (
            <div key={index} className="bg-[#F5F5F5] rounded-2xl overflow-hidden">
              <div className="grid lg:grid-cols-2 gap-8 p-8 lg:p-12">
                {/* Image */}
                <div className="order-2 lg:order-1">
                  <img
                    src={study.image}
                    alt={study.title}
                    className="w-full h-64 lg:h-80 object-cover rounded-lg"
                  />
                </div>

                {/* Content */}
                <div className="order-1 lg:order-2 space-y-6">
                  <div>
                    <h3 className="text-2xl md:text-3xl font-bold text-[#1A1A1A] mb-2">
                      {study.title}
                    </h3>
                    <span className="inline-block bg-[#2D7F3E] text-white px-3 py-1 rounded-full text-sm font-medium">
                      {study.sector}
                    </span>
                  </div>

                  {/* Challenge */}
                  <div>
                    <h4 className="text-lg font-semibold text-[#2D7F3E] mb-2 flex items-center">
                      <i className="ri-error-warning-line mr-2"></i>
                      Challenge
                    </h4>
                    <p className="text-gray-700">{study.challenge}</p>
                  </div>

                  {/* Solution */}
                  <div>
                    <h4 className="text-lg font-semibold text-[#2D7F3E] mb-2 flex items-center">
                      <i className="ri-lightbulb-line mr-2"></i>
                      Solution
                    </h4>
                    <p className="text-gray-700">{study.solution}</p>
                  </div>

                  {/* Results */}
                  <div>
                    <h4 className="text-lg font-semibold text-[#2D7F3E] mb-3 flex items-center">
                      <i className="ri-trophy-line mr-2"></i>
                      Results
                    </h4>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {study.results.map((result, resultIndex) => (
                        <div key={resultIndex} className="bg-[#2D7F3E] text-white p-3 rounded-lg text-center">
                          <div className="font-semibold text-sm">{result}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Testimonial */}
                  <div className="bg-white p-6 rounded-lg border-l-4 border-[#2D7F3E]">
                    <blockquote 
                      className="text-lg italic text-[#1A1A1A] mb-3"
                      
                    >
                      "{study.testimonial}"
                    </blockquote>
                    <div className="text-sm text-gray-600">
                      <div className="font-medium">{study.author}</div>
                      <div>{study.sector} Industry</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
